module.exports = __webpack_public_path__ + "img/ic_arrow2.1b66cf9f.svg";